export const FaqItemFields = `
{
    question
    answer
}
`;
